"use strict";
if (!Object.entries) {
    Object.entries = function (obj) {
        const ownProps = Object.keys(obj);
        let i = ownProps.length;
        const resArray = new Array(i); // preallocate the Array
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
    };
}
if (!Object.values) {
    Object.values = (obj) => Object.keys(obj).map((e) => obj[e]);
}
//# sourceMappingURL=polyfills.js.map